import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function CartPopover({ onClose }) {
  const { items, updateQty, removeItem } = useCart();
  return (
    <div className="cart-popover" data-testid="cart-popover">
      <div className="cart-title" data-testid="cart-popover-title">Warenkorb</div>
      {items.length === 0 ? <p className="muted" data-testid="cart-empty-message">Noch keine Teile ausgewählt.</p> : items.map((item) => (
        <div className="cart-row" key={item.part_id} data-testid={`cart-item-${item.part_id}`}>
          <div><strong data-testid={`cart-item-name-${item.part_id}`}>{item.name}</strong><span data-testid={`cart-item-order-${item.part_id}`}>{item.order_number}</span></div>
          <div className="qty-control" data-testid={`cart-item-qty-control-${item.part_id}`}>
            <button onClick={() => updateQty(item.part_id, Math.max(1, item.quantity - 1))} data-testid={`cart-item-decrease-${item.part_id}`}><Minus size={14} /></button>
            <span data-testid={`cart-item-quantity-${item.part_id}`}>{item.quantity}</span>
            <button onClick={() => updateQty(item.part_id, item.quantity + 1)} data-testid={`cart-item-increase-${item.part_id}`}><Plus size={14} /></button>
            <button onClick={() => removeItem(item.part_id)} data-testid={`cart-item-remove-${item.part_id}`}><Trash2 size={14} /></button>
          </div>
        </div>
      ))}
      <Link to="/checkout" onClick={onClose} className="primary-button full" data-testid="cart-popover-checkout-link">Zur Anfrage</Link>
    </div>
  );
}